var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 118.7 106.7",
    enableBackground: "new 0 0 118.7 106.7",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#4D4D4D",
    d: "M22.7,52.7c0,0,27.7,2.3,27.3,53c0,0-0.7-34.3-50-20.3C0,85.3,21.3,74.7,22.7,52.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114,0c-9.7,22-47.7,47-58.7,53.3c-3.9,2.2-6.4,4.4-8,6.2c0,0,0,0,0,0c-2.4,2.9-1.8,6.1-1.6,7c1.5,3,2.8,6.4,3.9,10.3 c2.3-9.1,17-16.4,36-26.5C121.3,31.3,114,0,114,0z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M5.1,87.2v11.4H1.2V87.2H5.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.3,97.2l8.1-7.8v-0.1H8.1v-2.1h12.4v1.5l-8,7.7v0.1h8.1v2.1H7.3V97.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2,98.6v-4.7l-5.4-6.7h4.4l1.8,2.7c0.5,0.8,0.9,1.4,1.3,2.2h0.1c0.4-0.7,0.8-1.4,1.3-2.2l1.7-2.7h4.3L31,93.9v4.8H27.2 z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DD272F",
    d: "M2.1,105.6l-0.4,1H0.2l1.9-3.9h1.8l1.9,3.9H4.3l-0.5-1H2.1z M3.7,105l-0.4-0.8c-0.1-0.2-0.2-0.5-0.3-0.8h0 c-0.1,0.2-0.2,0.5-0.3,0.8L2.3,105H3.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DD272F",
    d: "M8.4,102.7v3.9H7v-3.9H8.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DD272F",
    d: "M10,102.8c0.4,0,1.1-0.1,1.9-0.1c0.9,0,1.6,0.1,2,0.3c0.4,0.2,0.6,0.5,0.6,0.8c0,0.5-0.6,0.8-1.1,1v0 c0.4,0.1,0.7,0.4,0.8,0.7c0.2,0.4,0.4,1,0.5,1.1h-1.4c-0.1-0.1-0.2-0.4-0.4-0.9c-0.2-0.5-0.4-0.6-1-0.6h-0.4v1.5H10V102.8z  M11.4,104.4H12c0.7,0,1.1-0.2,1.1-0.6c0-0.4-0.4-0.5-1-0.5c-0.3,0-0.5,0-0.6,0V104.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DD272F",
    d: "M19.2,102.7h1.4v3.2H23v0.7h-3.9V102.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DD272F",
    d: "M25,103.4h-1.7v-0.7h4.8v0.7h-1.7v3.2H25V103.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DD272F",
    d: "M28.9,102.8c0.5-0.1,1.2-0.1,1.9-0.1c1.2,0,1.9,0.1,2.5,0.4c0.6,0.3,1,0.8,1,1.5c0,0.8-0.4,1.3-1,1.6 c-0.7,0.3-1.6,0.5-2.9,0.5c-0.7,0-1.2,0-1.6-0.1V102.8z M30.3,106c0.1,0,0.3,0,0.5,0c1.3,0,2.1-0.4,2.1-1.4c0-0.8-0.7-1.2-1.9-1.2 c-0.3,0-0.5,0-0.6,0V106z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#DD272F",
    d: "M50.8,84.8c0,0-2.2-11.5,16.7-17c15.7-5,36.2-11.7,51.2-27.8c0,0,3,25.2-27.2,30.7S56.5,75.8,50.8,84.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DD272F",
    d: "M59.5,80c0,0,5,0.5,8.2,2.2c3.2,1.7,30.5,10,37.2-5.8c0,0-2,2.3-7,2.3S66.5,75.5,59.5,80z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.baa2abaf9d4ed8ceb5d1527b340217cf.svg";
export { ForwardRef as ReactComponent };